// @ts-check
import './filter-modal.scss';
import { h } from 'preact';
import { useRef, useEffect } from 'preact/hooks';

import CloseButton from '../CloseButton';

import RadioFilter from './components/RadioFilter/RadioFilter';
import CheckboxFilter from './components/CheckboxFilter/CheckboxFilter';
import RangeFilter from './components/RangeFilter/RangeFilter';

const { __, _n, sprintf } = wp.i18n;

/**
 * @param {object} props
 * @param {string} props.mapId
 * @param {import('../../types').FilterWithValue[]} props.filters
 * @param {boolean} props.isActive
 * @param {number} props.numberOfResults
 * @param {number} props.numberOfFiltersActive
 * @param {(name: string, value) => void} props.onFilterChangeHandler
 * @param {(name: string, value) => void} props.onFilterResetHandler
 * @param {(name: string, value) => void} props.onFiltersResetHandler
 * @param {() => void} props.onCloseHandler
 * @param {(name: string, value) => number} props.getMatchCountForFilter
 * @param {boolean=} props.showNumberOfResultsInButton
 * @returns
 */
export default function FilterModal({
	mapId,
	children,
	filters,
	isActive,
	numberOfResults,
	numberOfFiltersActive,
	onFilterChangeHandler,
	onFilterResetHandler,
	onFiltersResetHandler,
	onCloseHandler,
	getMatchCountForFilter,
	showNumberOfResultsInButton = true
}) {
	const scrollContainer = useRef(null);

	useEffect(() => {
		if (scrollContainer.current && scrollContainer.current.nodeType === 1) {
			scrollContainer.current.scrollTop = 0;
		}
	}, [isActive]);

	/**
	 * @param {import('../../types').FilterWithValue} data
	 */
	function renderFilter(data) {
		switch (data.type) {
		case 'radio':
			return <RadioFilter {...data} id={`${mapId}-${data.name}`} onChangeHandler={onFilterChangeHandler} onResetHandler={onFilterResetHandler} getMatchCount={getMatchCountForFilter} />;
		case 'checkbox':
			return <CheckboxFilter {...data} id={`${mapId}-${data.name}`} onChangeHandler={onFilterChangeHandler} onResetHandler={onFilterResetHandler} getMatchCount={getMatchCountForFilter} />;
		case 'range':
			return <RangeFilter {...data} id={`${mapId}-${data.name}`} onChangeHandler={onFilterChangeHandler} onResetHandler={onFilterResetHandler} />;
		}
	}

	return (
		<div class={'filter-modal-container' + (isActive ? ' is-active' : '')} aria-hidden={!isActive} disabled={!isActive}>
			<div class="filter-modal-header-container">
				<h2 class="filter-modal-name">{__('Filters', 'real-estate-project')}</h2>
				<CloseButton onClickHandler={onCloseHandler} theme="dark" />
			</div>
			<div class="filter-modal-results-header-container">
				{sprintf(_n('%d result', '%d results', numberOfResults, 'real-estate-project'), numberOfResults)}
				{numberOfFiltersActive > 0 ?
					<button onClick={onFiltersResetHandler} class="filter-modal-reset-filters-button">{__('Reset filters', 'real-estate-project')}</button> : ''}
			</div>
			<div ref={scrollContainer} class="filter-modal-viewport-container">
				<div class="filter-modal-viewport-container-inner">
					{children}
					<form>
						{filters.map(filter => (
							renderFilter(filter)
						))}
					</form>
				</div>
			</div>
			<div class="filter-modal-footer-container">
				<button disabled={numberOfResults === 0} class="filter-modal-show-results-button button" onClick={onCloseHandler}>
					{numberOfResults === 0 ?
						__('No results', 'real-estate-project') :
						showNumberOfResultsInButton ? sprintf(_n('Show %d result', 'Show %d results', numberOfResults, 'real-estate-project'), numberOfResults) :
							__('Show results', 'real-estate-project')}
				</button>
			</div>
		</div>
	);
}
